<template>
  <v-container fluid grid-list-xs>
    <v-card>
      <v-card-text>
        <v-layout align-center row wrap>
          <v-flex xs2 class="primary--text pa-1 font-weight-black">Name:</v-flex>
          <v-flex v-if="billing" xs10 class="pa-1">{{ billing.name }}</v-flex>

          <v-flex v-if="billing.email" xs2 class="primary--text pa-1 font-weight-black">Email:</v-flex>
          <v-flex v-if="billing.email" xs10 class="pa-1">{{ billing.email }}</v-flex>

          <v-flex v-if="billing.phone" xs2 class="primary--text pa-1 font-weight-black">Phone:</v-flex>
          <v-flex v-if="billing.phone" xs10 class="pa-1">{{ billing.phone }}</v-flex>

          <v-flex xs2 class="primary--text pa-1 font-weight-black">Address:</v-flex>
          <v-flex v-if="billing" xs10 class="pa-1"><span>{{ formattedAddress }}</span></v-flex>

          <!--
          <v-flex xs6 sm2 class="primary--text pa-1 font-weight-black">Created:</v-flex>
          <v-flex v-if="billing" xs6 sm4 class="pa-1">{{ datetime(billing.created) }}</v-flex>

          <v-flex v-if="billing.modified" xs6 sm2 class="primary--text pa-1 font-weight-black">Modified:</v-flex>
          <v-flex v-if="billing.modified" xs6 sm4 class="pa-1">{{ datetime(billing.modified) }}</v-flex>
          -->
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import DisplayMixin from '@/mixins/display'

export default {
  mixins: [DisplayMixin],

  props: {
    billing: Object
  },

  computed: {
    formattedAddress () {
      let singleLine = true
      let address = ''

      if (singleLine) {
        let fields = [
          this.billing.address,
          this.billing.city,
          this.billing.state,
          this.billing.postal_code,
          this.billing.country
        ]

        for (let field of fields) {
          if (field) {
            address += field + ', '
          }
        }

        address = address.slice(0, -2)
      } else {
        if (this.billing.address) {
          address += this.billing.address + '<br />'
        }

        if (this.billing.city) {
          address += this.billing.city + ', '
        }
        if (this.billing.state) {
          address += this.billing.state + ', '
        }
        if (this.billing.postal_code) {
          address += this.billing.postal_code + ', '
        }

        if (address.endsWith(', ')) {
          address = address.slice(0, -2)
          address += '<br />'
        }
        address += '<br />'

        if (this.billing.country) {
          address += this.billing.country + '<br />'
        }
      }

      // address, city, state, postal_code, country
      // address
      // city, state, postal_code
      // country

      return address
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/terminal/components/BillingCard.vue